<!-- Meant for textures and gradiants-->
<script setup lang="ts">
import IOOverlayGradient from '../overlays/IOOverlayGradient.vue';
import IOOverlayTexture from '../overlays/IOOverlayTexture.vue';

const props = withDefaults(defineProps<{
  id: string,
  overlays: {
    transition: {
      mode: 'out-in'
    },
    overlays: []
  };
}>(), {
  id: '',   
  overlays: () => ({
    transition: {
      mode: 'out-in'
    },
    overlays: []
  })
})

const overlays = computed(() => props.overlays?.overlays || []);

watch(overlays, (newVal) => {
  console.log("overlays", newVal)
}, {
  immediate: true,
})

</script>

<template>
  <div v-if="overlays && overlays.length > 0" class="layer layer-overlays" :class="id">

    <!-- <div class="overlay navigation" /> -->
    <!-- <div class="overlay default-gradient" /> -->
    
    <slot name="overlays" />
    
   
    <component 
      v-for="(overlay, index) in overlays"
      :key="`${id}-overlay-${index}-${overlay.type}`"
      :is="overlay.type === 'gradient' ? IOOverlayGradient : IOOverlayTexture"
      :id="id" 
        :options="overlay.options" 
      />
    

  </div>
</template>



<style lang="scss" scoped>

.layer-overlays {
  position: relative;

  // :deep(>.m-wrap) {
  //   .io-hero-overlay {
  //     height: 100%;
  //     position: absolute;
  //     height: 100%;
  //     width: 100%;

  //     &.default-gradient {
  //       // background: rgba(0, 0, 0, 0.2)
  //       background: linear-gradient(180deg, rgba(80, 106, 251, 0.1) 0%, rgba(0, 0, 0, 0) 20%);
  //     }

  //     &.navigation {
  //       background: linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);
  //       height: 30%;
  //     }

  //     &.texture {
  //       background-image: url('/tex/default.png');
  //       opacity: 0.5;
  //       background-attachment: fixed;
  //     }
  //   }
  // }
}
</style>